import React from "react";

export default function EatInForm({
  user,
  guestName,
  setGuestName,
  tableNumber,
  setTableNumber,
  notes,
  setNotes,
  canAddServiceCharge,
  addServiceCharge,
  setAddServiceCharge,
  serviceChargeAmount,
  getUserFullName,
  eatInOption,
  setEatInOption,
}) {
  const handleOptionChange = (e) => {
    const value = e.target.value;
    setEatInOption(value);

    if (value === "take-away") {
      setTableNumber("");
      setAddServiceCharge(false);
    }
  };

  const isDineIn = eatInOption === "dine-in";

  return (
    <section>
      <div className="space-y-6 p-2">
        <div>
          <h2 className="text-xl font-semibold text-black">
            Customer Information
          </h2>
          <p className="text-sm text-black/60">
            Enter your details to send your order to the kitchen.
          </p>
        </div>

        <div>
          <div className="grid grid-cols-2 gap-3">
            <label
              className={`flex cursor-pointer items-center gap-3 rounded-2xl border-2 px-4 py-4 transition ${
                eatInOption === "dine-in"
                  ? "border-[#fa9324] bg-[#fa9324]/10"
                  : "border-black/10 bg-white hover:border-black/20"
              }`}
            >
              <input
                type="radio"
                name="eatInOption"
                value="dine-in"
                checked={eatInOption === "dine-in"}
                onChange={handleOptionChange}
                className="h-5 w-5 shrink-0 accent-[#fa9324]"
                style={{ border: "2px solid #ccc", appearance: "auto", WebkitAppearance: "auto" }}
              />
              <span className="font-semibold text-black">Dine In</span>
            </label>

            <label
              className={`flex cursor-pointer items-center gap-3 rounded-2xl border-2 px-4 py-4 transition ${
                eatInOption === "take-away"
                  ? "border-[#fa9324] bg-[#fa9324]/10"
                  : "border-black/10 bg-white hover:border-black/20"
              }`}
            >
              <input
                type="radio"
                name="eatInOption"
                value="take-away"
                checked={eatInOption === "take-away"}
                onChange={handleOptionChange}
                className="h-5 w-5 shrink-0 accent-[#fa9324]"
                style={{ border: "2px solid #ccc", appearance: "auto", WebkitAppearance: "auto" }}
              />
              <span className="font-semibold text-black">Take Away</span>
            </label>
          </div>
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-black">
            Your Name
          </label>

          {user ? (
            <input
              type="text"
              value={getUserFullName()}
              readOnly
              required
              className="w-full rounded-2xl border border-black/20 bg-black/5 px-4 py-3.5 text-sm text-black outline-none"
            />
          ) : (
            <input
              type="text"
              value={guestName}
              onChange={(e) => setGuestName(e.target.value)}
              required
              placeholder="Enter your full name"
              className="w-full rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
            />
          )}
        </div>

        {isDineIn && (
          <div>
            <label className="mb-2 block text-sm font-medium text-black">
              Table Number
            </label>
            <input
              type="text"
              value={tableNumber}
              onChange={(e) => setTableNumber(e.target.value)}
              required
              placeholder="Enter your table number"
              className="w-full rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
            />
          </div>
        )}

        <div>
          <label className="mb-2 block text-sm font-medium text-black">
            Notes <span className="text-black/50">(optional)</span>
          </label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={5}
            placeholder="Add any extra instructions"
            className="w-full resize-none rounded-2xl border border-black/20 bg-white px-4 py-3.5 text-sm text-black outline-none transition focus:border-[#fa9324] focus:ring-4 focus:ring-[#fa9324]/20"
          />
        </div>

        {canAddServiceCharge && isDineIn && (
          <div className="rounded-2xl border border-[#fa9324]/40 bg-[#fa9324]/10 p-4">
            <label className="flex cursor-pointer items-center justify-between">
              <p className="font-semibold text-black">Add Service Charge</p>

              <input
                type="checkbox"
                checked={addServiceCharge}
                onChange={() => setAddServiceCharge(!addServiceCharge)}
                className="h-5 w-5 accent-[#fa9324]"
              />
            </label>
          </div>
        )}
      </div>
    </section>
  );
}
